import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.ey{flex-shrink:0;}.ssr-plugin'
import '.g7{cursor:default;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Color, colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Text } from '../Text/index.js'

type LegendProps = {
  label: string
  color: Color
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  style?: Style
}

function Legend({
  label,
  color,
  onMouseEnter,
  onMouseLeave,
  style,
}: LegendProps) {
  return (
    <styled.div className="a d a3 ey g7"
      key={label}
      style={{
        ...style,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        style={{
          background: colors[color],
          flexShrink: 0,
          width: 4,
          height: 12,
          borderRadius: radius[4],
        }}
      />
      <Text singleLine variant="subtext-medium" color={color}>
        {label}
      </Text>
    </styled.div>
  )
}

export { Legend }
export type { LegendProps }
